import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Hidden from '@material-ui/core/Hidden'
import Fab from '@material-ui/core/Fab'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconSave } from 'assets/icons/save.svg'
import { ReactComponent as IconDownload } from 'assets/icons/download.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './actionsStyles'

const Actions = ({
  selectedCount,
  onSaveSearch,
  canSave,
  canDownload,
  onCSVExport,
}) => {
  const t = useTranslation()
  const classes = useStyles()
  const handleSaveSearch = useCallback(() => {
    onSaveSearch()
  }, [onSaveSearch])

  return (
    <>
      <Hidden smUp>
        <Box
          className={classes.actionsMobile}
          display="flex"
          alignItems="center"
        >
          {selectedCount ? (
            <IconButton
              className={classes.actionsButton}
              aria-label="add"
              color="primary"
              onClick={onCSVExport}
              disabled={!canDownload}
            >
              <SvgIcon component={IconDownload} />
            </IconButton>
          ) : (
            <>
              <IconButton
                className={classes.actionsButton}
                aria-label="add"
                color="primary"
                onClick={onCSVExport}
                disabled={!canDownload}
              >
                <SvgIcon component={IconDownload} />
              </IconButton>
              <Fab
                className={classes.actionsFab}
                color="primary"
                aria-label="add"
                onClick={handleSaveSearch}
              >
                <SvgIcon component={IconSave} />
              </Fab>
            </>
          )}
        </Box>
      </Hidden>
      <Hidden xsDown>
        <Box
          className={classes.actionsDesktop}
          mb={2}
          display="flex"
          alignItems="center"
        >
          <Button
            className={classes.actionsButton}
            variant="outlined"
            color="primary"
            startIcon={<SvgIcon component={IconDownload} />}
            onClick={onCSVExport}
            disabled={!canDownload}
          >
            {t('search:download-detail')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SvgIcon component={IconSave} />}
            onClick={handleSaveSearch}
            disabled={!canSave}
          >
            {t('search:save-search')}
          </Button>
        </Box>
      </Hidden>
    </>
  )
}

Actions.propTypes = {
  selectedCount: PropTypes.number,
  canDelete: PropTypes.bool,
  onRemoveVendors: PropTypes.func,
  canSave: PropTypes.bool,
  onCSVExport: PropTypes.func,
}

export default Actions
